<template>
	<div class="client_manage">
		<a-card title="公司办事处管理" :bordered="false">
			<!-- 搜索 -->
			<div class="search">
				<a-form layout="inline" :form="form" @submit="handleQuerySubmit">
					<a-form-item><a-input allowClear v-decorator="['name']" placeholder="请输入办事处名称"></a-input></a-form-item>

					<a-form-item><a-button type="primary" html-type="submit">查询</a-button></a-form-item>
				</a-form>
			</div>

			<!-- 操作栏 -->
			<div class="handle">
				<a-button type="primary" @click="toUrl('stores/add')">添加办事处地址</a-button>
				<a-divider type="vertical" />
				<a-button @click="delStores(false)">批量删除</a-button>
			</div>

			<!-- 表格 -->
			<div id="tableHeight">
				<a-table v-if="tableHeight>0" :scroll="{ x: 1247, y: tableHeight }" :rowSelection="{ selectedRowKeys: selectedRowKeysA, onChange: onSelectChangeA }" :columns="columns" :dataSource="dataSource" :loading="loading" :pagination="pagination" @change="onChange" :rowKey='record=>record.id'>
					<span slot="address" slot-scope="text, record">
						{{record.sheng}}{{record.shi}}{{record.xian}}{{record.address}}
					</span>
					
					<span slot="action" slot-scope="text, record">
						<a-button icon="form" size="small" @click="toUrl('stores/edit/' + record.id)">编辑</a-button>
						<a-divider type="vertical" />
						<a-button icon="delete" size="small" @click="delStores(record.id)">删除</a-button>
					</span>
				</a-table>
			</div>
			
		</a-card>

		<!-- 导出 -->
		<a-modal v-model="visible1" title="导出数据" :footer="null" width="540px">
			<div class="derive">
				<div @click="onDownload('This_page')">
					<a-icon type="file-text" style="font-size:26px;" />
					<div>导出本页</div>
				</div>

				<div @click="onDownload('whole')">
					<a-icon type="snippets" style="font-size:26px;" />
					<div>导出全部</div>
				</div>

				<div @click="onDownload('inquiry')">
					<a-icon type="file-search" style="font-size:26px;" />
					<div>导出查询</div>
				</div>
			</div>
		</a-modal>
	</div>
</template>

<script>
const columns = [
	{
		title: '办事处名称',
		key: 'name',
		dataIndex: 'name',
		width: 200
	},
	{
		title: '联系电话',
		key: 'mobile',
		dataIndex: 'mobile',
		width: 160
	},
	{
		title: '工作时间',
		key: 'business_hours',
		dataIndex: 'business_hours',
		width: 150
	},
	{
		title: '地址',
		key: 'address',
		scopedSlots: { customRender: 'address' },
		width: 300
	},
	{
		title: '添加时间',
		key: 'add_date',
		dataIndex: 'add_date',
		width: 170
	},
	{
		title: '操作',
		key: 'action',
		scopedSlots: { customRender: 'action' },
		width: 200,
		fixed: "right"
	}
];

import moment from 'moment';
export default {
	data() {
		return {
			loading: true,
			columns,
			usertrack: [],
			dataSource: [],
			visible: false,
			form: this.$form.createForm(this, { name: 'query_form' }),
			visible1: false,
			urls: '',
			pagination: {},
			
			selectedRowKeysA: [],
			selectedRowA: [],
			tableHeight: 0
		};
	},
	mounted() {
		this.initOrder();
		
		this.$nextTick(()=>{
			setTimeout(()=>{
				if(this.tableHeight == 0){
					if(document.getElementById('tableHeight')){
						this.tableHeight = document.getElementById('tableHeight').clientHeight-120
					}
					console.log(this.tableHeight)
					if(this.tableHeight<=0){
						this.tableHeight = 300
					}
				}
			},1)
		})
	},
	methods: {
		delStores(id){
			
			if(!id){
				id = this.selectedRowKeysA.join()
			}
			
			if(!id){
				this.$message.warn('请选择办事处！')
				return
			}
			
			let data = {
				id
			}
			
			let url = '?module=pc_api&action=Mch&app=del_store';
			this.$request.post(url,data).then(res => {
				let { code, message, data } = res;
				if(code == 200){
					this.$message.success(message)
					
					setTimeout(()=>{
						this.initOrder();
					},1000)
				}else{
					this.$message.error(message)
				}
			});
		},
		toUrl(url){
		  this.$router.push({ path: url })
		},
		onSelectChangeA(selectedRowKeys,selectedRow) {
		  this.selectedRowKeysA = selectedRowKeys;
		  this.selectedRowA = selectedRow
		},
		moment,
		onExport(url) {
			this.visible1 = !this.visible1;
			this.urls = url;
		},
		onChange(pagination) {
			this.initOrder({ page: pagination.current, ...pagination });
		},
		handtrcancal() {},
		handCancel() {
			this.form.resetFields();
			this.initOrder();
		},
		/**
		 * @name 查询
		 */
		handleQuerySubmit(e) {
			e.preventDefault();

			this.form.validateFields((err, values) => {
				if (!err) {
					let { name } = values;

					let data = { name, page:1 };
					this.initOrder(data);
				}
			});
		},
		/**
		 * @name 初始化页面数据
		 */
		initOrder(data = {page: 1}) {
			this.loading = true;

			this.$request.post('?module=pc_api&action=Mch&app=my_store', data).then(res => {
				let { code, message, data } = res;
				if (code === 200) {
					Object.assign(this, {
						dataSource: data.list,
						pagination: { total: data.total }
					});
				} else {
					this.$message.error(message);
				}

				setTimeout(() => {
					this.loading = false;
				}, 800);
			});
		},
		/**
		 * @name 表格操作回调
		 * */

		onCallback(callback, { text, record }) {
			callback.call(this, text, record);
		},
		/**
		 * @name 操作分割线
		 * */

		isDividerShow(i, list) {
			i += 1;
			if (list.length) {
				return i != list.length;
			}
		},
		/**
		 * @name 导出
		 */
		onDownload(pageto) {
			if (pageto === 'inquiry') {
				this.querybform.validateFields((err, values) => {
					if (!err) {
						let startdate;
						let enddate;

						let { mobile, range } = values;
						if (range) {
							// 开始时间
							startdate = range[0].format('YYYY-MM-DD HH:mm:ss');
							// 结束时间
							enddate = range[1].format('YYYY-MM-DD HH:mm:ss');
						}

						let data = { startdate, enddate };
						this.$request.download(this.urls + pageto, data);
					}
				});
				return;
			}

			this.$request.download(this.urls + pageto);
		}
	}
};
</script>

<style lang="less">
.client_manage {
	height: 100%;
	
	.search {
		padding: 8px 32px;
	}

	.handle {
		padding: 0px 32px;
		padding-bottom: 8px;
		display: flex;
		align-items: center;
	}
	
	.ant-card{
		display: flex;
		flex-direction: column;
		height: 100%;
		
		.ant-card-body{
			flex: 1;
			display: flex;
			flex-direction: column;
			
			#tableHeight{
				flex: 1;
			}
		}
	}
}

.derive {
	height: 200px;
	display: flex;
	justify-content: space-around;
	align-items: center;
	> div {
		width: 100px;
		height: 100px;
		border: 1px solid #03a2f4;
		border-radius: 4px;
		color: #03a2f4;
		font-size: 14px;
		transition: background-color 0.5s;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: space-evenly;
		cursor: pointer;
	}

	> div:hover {
		border: 0px solid #03a2f4;
		color: #ffffff;
		background: #2890ff;
	}
}
</style>
